<template>
  <custom-btn-icon
    @click.stop="handleClick"
    :btn-text="generateMessage('requests.actions.rejection')"
    color="error"
    icon="priority_high"
  />
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapActions } from 'vuex';
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';

export default {
  name: 'RejectionBtnDialog',
  components: {
    CustomBtnIcon,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    generateMessage,
    ...mapActions('modal', ['showModal']),
    handleClick() {
      this.showModal({
        componentName: 'RejectionDialog',
        componentProps: {
          requestId: this.requestId,
          technician_internal_id: this.technician_internal_id,
          entity_nav_full_id: this.entity_nav_full_id,
          isPaused: this.isPaused,
          isAssigned: this.isAssigned,
        },
        dialogProps: {
          width: '600px',
        },
      });
    },
  },
};
</script>
